export async function imageUrlToBase64(url: string): Promise<string> {
  // Fetch image
  const response = await fetch(url);

  // Check if fetch was successful
  if (!response.ok) {
    throw new Error(`Failed to fetch image. Status: ${response.statusText}`);
  }

  // Convert image to blob
  const blob = await response.blob();

  // Convert blob to base64
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert image to Base64.'));
      }
    };
    reader.onerror = () => {
      reject(new Error('Failed to read the blob as data URL.'));
    };
    reader.readAsDataURL(blob);
  });
}
